exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  font-family: Dosis, Helvetica, Arial, sans-serif !important;\n  overflow-x: hidden; }\n\nh1 {\n  color: white !important; }\n\np {\n  font-size: 1.3em !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/rafaelneves/code/ads/ardaexperience/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/rafaelneves/code/ads/ardaexperience/node_modules/postcss-loader?{"ident":"postcss"}!/home/rafaelneves/code/ads/ardaexperience/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/home/rafaelneves/code/ads/ardaexperience/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles